import React, { useContext, useEffect } from 'react';
import EmailProcessingCard from '../cards/EmailProcessingCard';
import { EMAIL_PROCESSING_STATS } from '@/api/queries';
import { MAILBOXES_STATS_SUBSCRIPTION } from '@/api/subscriptions';
import { useQuery } from '@apollo/client';
import { AuthContext } from '@/context/AuthContext';

const EmailProcessingSection = () => {
    const { subscribeToMore, data } = useQuery(EMAIL_PROCESSING_STATS);
    const { user } = useContext(AuthContext);

    useEffect(()=>{
        if (!data || !user?.id) return;

        const unsubscribe = subscribeToMore({
              document: MAILBOXES_STATS_SUBSCRIPTION,
              variables: { userId: user.id },
              updateQuery: (prev, { subscriptionData }) => {
                if (!subscriptionData.data) return prev;

                const newItem = subscriptionData.data.mailboxesStatSubscription;
      
                return Object.assign({}, prev, {
                    emailProcessingStats: newItem,
                });
              },
            });
      
            return () => {
              unsubscribe();
            };
    },[data, subscribeToMore, user?.id])

    return (
        <EmailProcessingCard emailProcessingStats={data?.emailProcessingStats}/>
    )
}

export default EmailProcessingSection;